module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "persistent": "",
      "width": "auto"
    }
  }, [_c('v-card', {
    attrs: {
      "height": "auto"
    }
  }, [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("\n\t\t\tAgregar Producto\n\t\t")]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "mb-4": ""
    }
  }, [_c('v-divider')], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": "",
      "pl-3": ""
    }
  }, [_c('v-subheader', {
    staticClass: "pl-0"
  }, [_vm._v("\n\t\t\t\t\tAlmacenes\n\t\t\t\t")]), _vm._v(" "), _c('v-select', {
    staticClass: "filter-select",
    attrs: {
      "hide-details": "",
      "item-text": "name",
      "item-value": "id",
      "items": _vm.warehouses
    },
    model: {
      value: (_vm.productWarehouse),
      callback: function($$v) {
        _vm.productWarehouse = $$v
      },
      expression: "productWarehouse"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": "",
      "pl-3": ""
    }
  }, [_c('v-subheader', {
    staticClass: "pl-0"
  }, [_vm._v("\n\t\t\t\t\tCategorías\n\t\t\t\t")]), _vm._v(" "), _c('v-select', {
    staticClass: "filter-select",
    attrs: {
      "hide-details": "",
      "item-text": "name",
      "item-value": "id",
      "items": _vm.categories
    },
    model: {
      value: (_vm.productCategory),
      callback: function($$v) {
        _vm.productCategory = $$v
      },
      expression: "productCategory"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs1": "",
      "pl-3": "",
      "text-xs-left": "",
      "pt-5": ""
    }
  }, [_c('v-btn', {
    staticClass: "btn-success white--text",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.filterProducts
    }
  }, [_c('v-icon', [_vm._v("filter_list")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "mt-5": ""
    }
  }, [_c('table-run', {
    attrs: {
      "columns": _vm.productColumns,
      "rows": _vm.productRows,
      "include-delete": false,
      "include-export-to-excel": false,
      "include-options": false,
      "include-switch": false,
      "include-settings": false,
      "include-delete-single": false,
      "selectable": ""
    },
    on: {
      "on-search-event": _vm.searchProductsByColumn
    },
    scopedSlots: _vm._u([{
      key: "rows",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.row.code))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.warehouseName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.categoryName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.stock))]), _vm._v(" "), _c('td', {
          staticClass: "px-2"
        }, [_c('v-text-field', {
          staticClass: "input-border-inset width-60",
          attrs: {
            "type": "number"
          },
          on: {
            "keyup": function($event) {
              _vm.positiveValue(props.row, 'quantity')
            }
          },
          model: {
            value: (props.row.quantity),
            callback: function($$v) {
              props.row.quantity = _vm._n($$v)
            },
            expression: "props.row.quantity"
          }
        })], 1), _vm._v(" "), _c('td', {
          staticClass: "text-xs-center"
        }, [_vm._v(_vm._s(props.row.price))]), _vm._v(" "), _c('td', {
          staticClass: "px-2 d-flex"
        }, [_c('v-text-field', {
          staticClass: "input-border-inset basis-30 mr-2",
          attrs: {
            "type": "number"
          },
          on: {
            "keyup": function($event) {
              _vm.positiveValue(props.row, 'discount')
            }
          },
          model: {
            value: (props.row.discount),
            callback: function($$v) {
              props.row.discount = _vm._n($$v)
            },
            expression: "props.row.discount"
          }
        }), _vm._v(" "), _c('span', {
          staticClass: "basis-70"
        }, [_vm._v("%")])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-right": ""
    }
  }, [_c('v-pagination', {
    attrs: {
      "length": _vm.totalModalPages,
      "total-visible": _vm.pagesVisible
    },
    on: {
      "input": function($event) {
        _vm.loadSummaryProducts(_vm.paramsSummary.page)
      }
    },
    model: {
      value: (_vm.paramsSummary.page),
      callback: function($$v) {
        _vm.paramsSummary.page = $$v
      },
      expression: "paramsSummary.page"
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "my-3": "",
      "align-end": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs2": "",
      "pr-2": ""
    }
  }, [_c('v-btn', {
    staticClass: "btn-action",
    attrs: {
      "type": "button",
      "primary": ""
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("\n\t\t\t\t\t\tCancelar\n\t\t\t\t\t")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": "",
      "pl-2": ""
    }
  }, [_c('v-btn', {
    staticClass: "btn-action btn-success white--text",
    attrs: {
      "disabled": _vm.addProductsDisabled
    },
    nativeOn: {
      "click": function($event) {
        _vm.updateProducts($event)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\tGuardar\n\t\t\t\t\t")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-945e26b0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/clerkinn/shared/payment-dialog.vue
// module id = 1686
// module chunks = 22